import { TableColumn, TableRow } from 'react-md'
import type {
	AccountingSetting,
	AccountingSettingRow as SettingRow,
} from './types'
import { accountingSettingHeaders } from './constants'
import { useIntl } from 'react-intl'
import AccountingSettingFormInput from './AccountingSettingFormInput'

type Props = {
	accountingSetting: AccountingSetting
	settingRow: SettingRow
}

const AccountingSettingRow = ({ accountingSetting, settingRow }: Props) => {
	const intl = useIntl()

	const renderTableColumns = () => {
		return accountingSettingHeaders
			.filter((h) => h.show)
			.map((header) => {
				if (
					(header.key === 'status' && settingRow.hideStatus) ||
					(header.key === 'account' && !settingRow.showAccount)
				) {
					return <TableColumn key={header.key}></TableColumn>
				}
				if (header.key === 'section') {
					return (
						<TableColumn key={header.key}>
							<p>{settingRow.title(intl)}</p>
						</TableColumn>
					)
				} else
					return (
						<TableColumn key={String(header.key)}>
							<AccountingSettingFormInput input={header} />
						</TableColumn>
					)
			})
	}

	return (
		<TableRow
			key={String(settingRow.key) + String(accountingSetting.uuid)}
			style={{ border: 'none' }}
		>
			{renderTableColumns()}
		</TableRow>
	)
}

export default AccountingSettingRow
